import React, { Fragment, useEffect, useState } from "react";
import "../../styles/component.css";
import { Link } from "react-router-dom";
import { post } from "../../effects/api/api.common";
import { GET_PORTFOLIO } from "../../constants/api";
import { filterByValue, filterByValue1 } from "../../utils/CommonMethods";
import search from "../../../src/images/search.svg"

const Portfolio = () => {
  const [data, setData] = useState<any[]>([]);
  const [portfolioList, setPortfolioList] = useState([]);
  const [des, setDes] = useState("");

  const getPortfolio = () => {
    // @ts-ignore
    post(GET_PORTFOLIO).then((response: any) => {
      if (!response || !response.data) return;
      if (response?.data?.result === "success") {
        // console.log("res", response.data.data);
        setData(response.data.data);
      } else {
        setData([]);
      }
    });
  };

  useEffect(() => {
    getPortfolio();
    
  }, []);
  const [show, setShow] = useState(false)
  const searchList = (e: any) => {
    
    const filteredData = filterByValue1(data, e.target.value);

    setShow(true)
    setPortfolioList(filteredData);
  }
  return (
    <Fragment>
      <main role="main">
        <div className="about-container portfolio-container">
          <div className="container-fluid about-heading">
            <div className="text-center main-heading">Portfolio</div>
          </div>
        </div>


        <div className="container mt-5 mb-5">
          <div className="col-md-12">
            <ul>
              <li>
                Certain incubators listed on this page may not be available in
                the drop-down menus of the startup application form in case the
                said incubators are unable to receive more applications. Please
                reach out to{" "}
                <a href="mailto:sisfs@investindia.org.in">
                  <u className="link-orange-text">sisfs@investindia.org.in</u>
                </a>{" "}
                for any queries related to the same.
              </li>
            </ul>
            <div className="row">
              <div className="col-md-8">
                <h1 className="portMainHeading">Selected Incubators</h1>
              </div>
              <div className="col-md-4 pull-right">
                <div className="portFoundText pull-right">
                  <div className="d-flex searchDiv">
                    {" "}
                    <img src={search} className="search" alt="search" />
                    <input
                      className="searchBar"
                      type="text"
                      placeholder=" Search.."
                      name="search"
                      onKeyUp={searchList}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="col-md-4 pull-right">
                                <p className="portFoundText pull-right">{data.length} Found</p>
                            </div> */}
            </div>
            
            {show &&
              <div className="row">
                {
                // data.length == 0 ? (
                //     <div>
                //         No Data
                //     </div>
                // ) : 
                    
                    !portfolioList.length  ? (
                        
                           <div className="col-md text-center mt-5">
                            <h4>No Results Found</h4>
                           </div>
                    ) :  (
                        
                        portfolioList.map(
                            (key:any,index,) => 
                            {
                                return (
                                  
                                  <Fragment key={index}>
                                    <div className="col-md-4">
                                      <div className="portFolioGrid">
                                        <Link
                                          to={{
                                            pathname: "/portfolio_detail",
                                            state: { portfolioId: index + 1 },
                                          }}
                                          className="portLink"
                                        >
                                          <div className="portImageBlock">
                                            <img
                                              src={key.image}
                                              alt={key.incubator_name}
                                              className="portImage"
                                            />
                                          </div>
                                          <div className="portContentBlock">
                                            <p className="portCity">
                                              {key.city},{" " + key.state}
                                            </p>
                                            <h1 className="portHeading twoLine">
                                              {key?.incubator_name}
                                            </h1>
                                            <p className="portDescription twoLine">
                                              {key?.description}
                                            </p>
              
                                            {key?.sectors.length > 0 && (
                                              <p className="portTag">
                                                <span>{key?.sectors[0]}</span>
                                                {key?.sectors.length > 1 && (
                                                  <span>
                                                    {" "}
                                                    +{key.sectors.length - 1} More{" "}
                                                  </span>
                                                )}
                                              </p>
                                            )}
                                          </div>
                                        </Link>
                                      </div>
                                    </div>
                                  </Fragment>
                                );
                              }
                        )
                    )
                    
            }
            </div>
            }
            
            {!show &&
              <div className="row">
              {data &&
                data.length > 0  &&
                data.map((key, index) => {
                  return (
                    
                    <Fragment key={index}>
                      <div className="col-md-4">
                        <div className="portFolioGrid">
                          <Link
                            to={{
                              pathname: "/portfolio_detail",
                              state: { portfolioId: index + 1 },
                            }}
                            className="portLink"
                          >
                            <div className="portImageBlock">
                              <img
                                src={key.image}
                                alt={key.incubator_name}
                                className="portImage"
                              />
                            </div>
                            <div className="portContentBlock">
                              <p className="portCity">
                                {key.city},{" " + key.state}
                              </p>
                              <h1 className="portHeading twoLine">
                                {key?.incubator_name}
                              </h1>
                              <p className="portDescription twoLine">
                                {key?.description}
                              </p>

                              {key?.sectors.length > 0 && (
                                <p className="portTag">
                                  <span>{key?.sectors[0]}</span>
                                  {key?.sectors.length > 1 && (
                                    <span>
                                      {" "}
                                      +{key.sectors.length - 1} More{" "}
                                    </span>
                                  )}
                                </p>
                              )}
                            </div>
                          </Link>
                        </div>
                      </div>
                    </Fragment>
                  );
                })}
                
            </div>
            }
            
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default Portfolio;
